import { Component, h, Host, Prop } from '@stencil/core'
import { VariantSwitchItem } from './types'
import { toMoney } from '@rdss/core';

@Component({
    tag: 'zr-variant-switch-list-item',
    styleUrl: './zr-variant-switch-list-item.scss',
    shadow: true,
})
/**
 * Variant list item.
 */
export class ZrVariantSwitchListItem {
    /**
     * This is a variant switch item.
     */
    @Prop() variant: VariantSwitchItem

    /**
     * This marks the product as the best value for money offer.
     */
    @Prop() hasLowestPricePerUnit: boolean

    /**
     * Locale used for currencies.
     */
    @Prop() locale: string

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (
            <Host>
                {this.variant?.price &&
                    <div class='zr-variant-list-item__inner-container'>
                        <input
                            class="zr-variant-list-item__input"
                            type="radio"
                            id={`radio${this.variant.id}`}
                            name="variantGroup"
                            checked={this.variant.selected}
                            aria-disabled={!this.variant.isAvailable}
                        />
                        <label htmlFor={`radio${this.variant.id}`}
                            class={{
                                'zr-variant-list-item__label': true,
                                'zr-variant-list-item__label--notAvailable': !this.variant.isAvailable,
                            }}>
                            <svg class={{
                                'zr-variant-list-item__radio': true,
                                'zr-variant-list-item__radio--notAvailable': !this.variant.isAvailable,
                            }}
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                                <g transform="translate(1.5 1.5)" fill="none" stroke="currentColor">
                                    <circle class={{
                                        'zr-variant-list-item__radio--inner': this.variant.isAvailable,
                                        'zr-variant-list-item__radio--inner--notAvailable': !this.variant.isAvailable,
                                    }}
                                    y="13.5" cx="10.5" cy="10.5" r="7.9"
                                    fill="currentColor" stroke-width="1.5" />
                                    <circle cx="10.5" cy="10.5" r="11.2" stroke="currenColor" />
                                </g>
                            </svg>
                            <div class="zr-variant-list-item__header">
                                <span>{this.variant.text}</span>
                                {this.hasLowestPricePerUnit &&
                                    <div class="zr-variant-list-item__icon" title={this.variant.title}></div>
                                }
                            </div>
                            <div>
                                <div class="zr-variant-list-item__price" >
                                    {toMoney(this.variant.price.gross, this.variant.price.currency, this.locale)}
                                </div>
                                {this.variant.unit.unit &&
                                    <div class="zr-variant-list-item__per-unit">
                                        {toMoney(this.variant.price.pricePerUnit,
                                            this.variant.price.currency,
                                            this.locale)}&nbsp;/&nbsp;
                                        {this.variant.unit.referenceUnit} {this.variant.unit.unit}
                                    </div>
                                }
                            </div>
                        </label>
                    </div>
                }
            </Host>
        )
    }
}
